import { Context, createContext } from 'react';

/**
 * React app source context object for logging actionSource in Datapoint
 */
export const ReactAppSourceContext: Context<string> = createContext<string>(undefined);
